import { PropsWithChildren, ReactElement } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate } from 'react-router-dom';
import './header.component.scss';

export interface HeaderComponentProps extends PropsWithChildren {
  logo?: ReactElement;
}
const HeaderComponent = ({ children, logo }: HeaderComponentProps) => {
  const navigate = useNavigate();
  const onClickHandle = () => {
    navigate('/');
  };
  return (
    <Navbar className="header-component" expand="md" fixed="top">
      <div className="container-fluid">
        <Navbar.Brand
          className="cursor-pointer app-nav-brand"
          onClick={() => onClickHandle()}
        >
          <span className="logo-container pe-3">{logo}</span>
        </Navbar.Brand>

        {children}
      </div>
    </Navbar>
  );
};

export default HeaderComponent;
